const sensitiveKey =
    /password|secret|token|authorization|cookie|session|api.?key|access.?key|csrf|oauth|credential/i;

/** Copy diagnostic state without functions, circular references, or credentials. */
export function copySupportContext(
    value: any,
    depth = 0,
    seen = new WeakSet<object>()
): any {
    if (depth > 8) return '[Maximum depth reached]';
    if (value === null || typeof value === 'boolean' || typeof value === 'number')
        return value;
    if (typeof value === 'string') return value.slice(0, 4000);
    if (value instanceof Date) return value.toISOString();
    if (!value || typeof value !== 'object') return null;
    if (seen.has(value)) return '[Circular reference]';
    seen.add(value);
    let result: any;
    if (Array.isArray(value))
        result = value.slice(0, 2000).map(v => copySupportContext(v, depth + 1, seen));
    else {
        result = {};
        for (const [key, item] of Object.entries(value).slice(0, 100)) {
            if (
                !sensitiveKey.test(key) &&
                !['__proto__', 'prototype', 'constructor'].includes(key) &&
                typeof item !== 'function'
            ) {
                result[key] = copySupportContext(item, depth + 1, seen);
            }
        }
    }
    seen.delete(value);
    return result;
}

export function supportPageUrl(value: string): string {
    try {
        const url = new URL(value);
        url.username = '';
        url.password = '';
        for (const key of [...url.searchParams.keys()]) {
            if (
                !['product', 'hotel', 'htl_id', 'year', 'month', 'currency'].includes(key)
            )
                url.searchParams.delete(key);
        }
        url.hash = '';
        return url.toString();
    } catch {
        return '';
    }
}
